import Auth from '@aws-amplify/auth';
import Amplify from '@aws-amplify/core';
import merge from 'lodash/merge';
import appSettings from '@/app-settings';

window.Amplify = Amplify;
window.Auth = Auth;

export class CognitoLoginMgr {
  static VERSION = '1';

  static LAST_AUTHED_EMAIL_LS_KEY = `lastAuthedEmail_v${CognitoLoginMgr.VERSION}`;

  static cognitoClientConfigMap = null;

  static instance = null;

  static getInstance() {
    if (!CognitoLoginMgr.cognitoClientConfigMap) {
      throw new Error('CognitoLoginMgr cannot be instantiated before setup');
    }
    if (!CognitoLoginMgr.instance) {
      CognitoLoginMgr.instance = new CognitoLoginMgr();
    }
    return CognitoLoginMgr.instance;
  }

  static setup(configMap) {
    const defaultConfig = { default: appSettings.awsConfig.Auth };
    const cogMap = merge(configMap, defaultConfig);
    CognitoLoginMgr.cognitoClientConfigMap = cogMap;
  }

  /*
   * There is a way to get, set the last authed email directly from the values stored
   * by amplify in localstorage.. But this is simpler. TODO: Consider maintaining these values
   * through Amplify if this ever gives us a headache
   */

  static async setLastAuthedEmail(email) {
    window.localStorage.setItem(
      CognitoLoginMgr.LAST_AUTHED_EMAIL_LS_KEY,
      email
    );
  }

  static async getLastAuthedEmail() {
    return window.localStorage.getItem(
      CognitoLoginMgr.LAST_AUTHED_EMAIL_LS_KEY
    );
  }

  static async clearLastAuthedEmail() {
    window.localStorage.removeItem(CognitoLoginMgr.LAST_AUTHED_EMAIL_LS_KEY);
  }

  static async signOut() {
    CognitoLoginMgr.clearLastAuthedEmail();
    await Auth.signOut();
  }

  constructor() {
    CognitoLoginMgr.instance = this;
  }

  clientConfigFactory = (email) => {
    const emailDomain = String(email)?.split('@').pop().toLowerCase();
    const maybeCid = CognitoLoginMgr.cognitoClientConfigMap[emailDomain];
    return maybeCid || CognitoLoginMgr.cognitoClientConfigMap.default;
  };

  /**
   * Will configure amplify. If passed an email, will find client id for that email
   * in order to support SSO. If no email passed, will assume regular sign in
   *
   * @param {*} email optional
   */
  amplifyConfigure = (email) => {
    const config = this.clientConfigFactory(email);
    Amplify.configure({ Auth: config });
  };

  registerLoginSuccess = (email) => {
    CognitoLoginMgr.setLastAuthedEmail(email);
  };

  isSSOEmail = (email) => {
    const config = this.clientConfigFactory(email);
    return Boolean(config.oauth);
  };

  getSSOLoginUrl = (email) => {
    const authConfig = this.clientConfigFactory(email);

    if (!authConfig.oauth) {
      throw new Error('Oauth config not available for this email address');
    }

    return `https://${authConfig.oauth.domain}/authorize?idp_identifier=${authConfig.oauth.idpIdentifier}&response_type=code&state=${email}&client_id=${authConfig.userPoolWebClientId}&redirect_uri=${authConfig.oauth.redirectSignIn}`;
  };
}

window.CLM = CognitoLoginMgr;
